/**
 * @phxAx
 */
angular
  .module('ui-ng-ax', ['ui-ng-delegate'])
  .controller('phxAxController', function Controller($scope) {})
  .constant('phxAxDelegateConstant', {
    uniqueComponent: 'phx-ax',
    vocabulary: {}
  })
  .directive('phxAx', function (DelegateResponder, phxAxDelegateConstant) {
    return {
      restrict: 'E',
      replace: false,
      templateUrl: 'ui-ng-ax/src/templates/standard.html',
      controller: 'phxAxController',
      scope: {
        ngModel: '='
      },
      compile: function Compile(element, attrs) {
        return DelegateResponder(phxAxDelegateConstant, function (scope, element, attrs) {});
      }
    };
  })
  .service('phxAxDelegate', function (DelegateController, phxAxDelegateConstant) {
    DelegateController(this, phxAxDelegateConstant);
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-ax/src/core.js